import * as React from 'react';
import QRCode from 'qrcode';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { DataService } from '../../services/data_service';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { csvToJsonAnAbreise } from './functions/csvToJsonAnAbreise';
import { getStaticOption } from '../../core/forms/helpers/getStaticOption';
import { fn2d, fn0 } from '../../core/formatter/formatNumber';
import * as config from '../../wips.config.js';

export interface DateneingabeAnAbreiseDetailProps {
    rowTid: number;
    data: any;
    onClose: () => void;
}

export interface DateneingabeAnAbreiseDetailState {
    dataItem?: any;
    logo?: string;
    qrUrl?: string;
    showSpinner?: boolean;
}

export class DateneingabeAnAbreiseDetail extends React.Component<DateneingabeAnAbreiseDetailProps, DateneingabeAnAbreiseDetailState> {

    constructor(props: any) {
        super(props);
        this.state = {

        };
        this.openAnAbreiseTool = this.openAnAbreiseTool.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.renderQRcode = this.renderQRcode.bind(this);
        this.processData = this.processData.bind(this);
        this.updateDataItem = this.updateDataItem.bind(this);

        this.anreiseUrl = config.anreiseUrl;
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(DataService) private dataService: DataService;

    private standortOrt: string;
    private anreiseUrl: string;

    componentDidMount(): void {
        this.loadLogo();
        this.updateDataItem();
    }

    componentDidUpdate(prevProps: Readonly<DateneingabeAnAbreiseDetailProps>, prevState: Readonly<DateneingabeAnAbreiseDetailState>): void {
        this.updateDataItem(prevState);
    }

    loadLogo() {
        const uData = this.props.data[IDs.ENT_UNTERNEHMENSDATEN][0] || {};
        if (uData.datei_logo > 0) {
            this.dataService.loadDataForModul(IDs.ENT_ARCHIV_ITEMS, { tid: uData.datei_logo }, { resolve: true, fieldList: 'name, file' }, 'wips', (result: any) => {
                if ((result[IDs.ENT_ARCHIV_ITEMS] || []).length) {
                    let logo: string = result[IDs.ENT_ARCHIV_ITEMS][0].file;
                    if (logo) {
                        this.setState({ logo });
                    }
                }
            });
        }
    }

    updateDataItem(prevState?: any) {
        if (this.props.rowTid > 0 && this.props.data && Array.isArray(this.props.data[IDs.ENT_ANABREISE])) {
            const standorte = this.props.data[IDs.ENT_STANDORT];
            const rowFnd = this.props.data[IDs.ENT_ANABREISE].find((r: any) => r.tid === this.props.rowTid);
            const rowStandortTid = rowFnd && rowFnd.standort_tid_orig > 0 ? rowFnd.standort_tid_orig : rowFnd.standort_tid > 0 ? rowFnd.standort_tid : null;
            if (rowStandortTid > 0) {
                const standort = standorte.find((s: any) => s.tid === rowStandortTid);
                if (standort) {
                    if (standort.standort_typ_tid_orig === 5 /* Veranstaltung - eigener Standort */) {
                        const standort2 = standorte.find((s: any) => s.tid === standort.standort_tid_orig);
                        this.standortOrt = standort2 ? standort2.ort : standort.ort;
                    } else if (standort.standort_typ_tid_orig === 6 /* Veranstaltung - externer Standort */) {
                        this.standortOrt = standort.ort;
                    } else {
                        this.standortOrt = standort.ort;
                    }
                }
            }
            if (rowFnd) {
                if (JSON.stringify(rowFnd) !== JSON.stringify(this.state.dataItem)) {
                    this.setState({ dataItem: rowFnd });
                    this.renderQRcode(rowFnd);
                } else if ((!prevState && this.state.logo) || (prevState && this.state.logo !== prevState.logo)) {
                    this.renderQRcode(rowFnd);
                }
            }
        }
    }

    render(): JSX.Element {
        if (!this.state.dataItem) {
            return null;
        }
        const row = this.state.dataItem;
        return <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
            <div style={{ marginLeft: 20 }}>
                <div style={{ paddingRight: 10 }}>Kampagne: <b>{row.name}</b></div>
                <WActionButton
                    label='An-/Abreise-Tool öffnen'
                    insideText='An-/Abreise-Tool öffnen'
                    insideLeftMargin={0}
                    key='btn_open'
                    styleProps={{ margin: 0, width: 300, marginTop: 20 }}
                    action='open'
                    onAction={() => this.openAnAbreiseTool()}
                />
                <WActionButton
                    label='Daten importieren'
                    insideText='Daten importieren'
                    insideLeftMargin={0}
                    key='btn_edit'
                    styleProps={{ margin: 0, width: 300, marginTop: 20 }}
                    action='open'
                    onAction={() => this.setState({ showSpinner: true }, () => this.processData(row.kennung))}
                />
                <WActionButton
                    label='Link in die Zwischenablage kopieren'
                    insideText='Link in die Zwischenablage kopieren'
                    insideLeftMargin={0}
                    styleProps={{ margin: 0, width: 300, marginTop: 20 }}
                    key='btn_copy'
                    action='open'
                    onAction={() => this.copyToClipboard()}
                />
                {this.state.qrUrl && <img alt='QR' src={this.state.qrUrl} />}
                <WActionButton
                    label='Daten als CSV herunterladen'
                    insideText='Daten als CSV herunterladen'
                    insideLeftMargin={0}
                    styleProps={{ margin: 0, width: 300 }}
                    key='btn_csv'
                    action='open'
                    onAction={() => this.exportCSV(row)}
                />
            </div>
            <div>
                {this.renderResults()}
            </div>
        </div>;
    }

    renderResults() {
        const jsonStr = this.state.dataItem.ergebnis;
        let results: any;
        try {
            results = JSON.parse(jsonStr);
        } catch (e) {
            console.error(e, jsonStr);
        }
        if (!results || !results.entfernungen) {
            return <div>Es wurden noch keine Daten erfasst und/oder verarbeitet!</div>;
        }

        const transportation = Object.keys(results.entfernungen || {}).map((k: string) => {
            return {
                key: k,
                ...results.entfernungen[k]
            };
        }).sort((a: any, b: any) => b.km - a.km);
        const uebernachtung = Object.keys(results.uebernachtungen || {}).map((k: string) => {
            return {
                key: k,
                ...results.uebernachtungen[k]
            };
        }).sort((a: any, b: any) => b.anzahl - a.anzahl);
        const besucher_erwartet = this.state.dataItem.besucher;
        const besucher_erfasst = this.state.dataItem.besucher_erfasst;
        const faktor_hochrechnung = (besucher_erwartet / besucher_erfasst) || 1;
        const style_field = { width: '100px', fontSize: '11px', backgroundColor: '#F0F0F0', borderBottom: '1px solid #AAA', padding: '3px' };
        const style_field_b: React.CSSProperties = { ...style_field, fontWeight: 'bold', textAlign: 'right' };
        const style_field_r: React.CSSProperties = { ...style_field, textAlign: 'right' };
        const style_field_b220: React.CSSProperties = { ...style_field_b, textAlign: 'left', width: '220px' };

        return <div style={{ margin: '10px' }}>
            {transportation.length > 0 && <React.Fragment>
                <div style={{ backgroundColor: '#888', fontWeight: 'bold', color: '#FFF', marginBottom: '10px', padding: '3px' }}>
                    Entfernungen
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                    <div style={style_field_b220}>Transportmittel</div>
                    <div style={style_field_b}>Entfernung (km) erfasst</div>
                    <div style={style_field_b}>Personen erfasst</div>
                    <div style={style_field_b}>Entfernung (km) hochgerechnet</div>
                </div>
                {transportation.map((t: any) =>
                    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                        <div style={style_field_b220}>{getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'transportmittel', t.key)}</div>
                        <div style={style_field_r}>{fn0(t.km)}</div>
                        <div style={style_field_r}>{fn0(t.cnt)}</div>
                        <div style={style_field_r}>{fn2d(Math.round(t.km * faktor_hochrechnung))}</div>
                    </div>)}
            </React.Fragment>
            }
            {uebernachtung.length > 0 && <React.Fragment>
                <div style={{ backgroundColor: '#888', fontWeight: 'bold', color: '#FFF', marginBottom: '10px', marginTop: '10px', padding: '3px' }}>
                    Übernachtungen
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                    <div style={style_field_b220}>Unterkunft</div>
                    <div style={style_field_b}>Übernachtungen erfasst</div>
                    <div style={style_field_b}>Personen erfasst</div>
                    <div style={style_field_b}>Übernachtungen hochgerechnet</div>
                </div>
                {uebernachtung.map((u: any) =>
                    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                        <div style={style_field_b220}>{getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'unterkunft', u.key)}</div>
                        <div style={style_field_r}>{fn0(u.anzahl)}</div>
                        <div style={style_field_r}>{fn0(u.cnt)}</div>
                        <div style={style_field_r}>{fn2d(Math.round(u.anzahl * faktor_hochrechnung * 100) / 100)}</div>
                    </div>)}
            </React.Fragment>
            }
        </div>;
    }

    getToolUrl(kampagne?: any) {
        kampagne = kampagne || this.state.dataItem;
        if (!kampagne || !kampagne.kennung) {
            alert('Fehler: Unbekannte Kennung.\nBitte speichern Sie den Datensatz erneut!');
            this.props.onClose();
            return false;
        }
        const data = {
            name: kampagne.name,
            jahr: kampagne.jahr,
            logo: this.state.logo,
            ort: this.standortOrt
        }
        const { kennung } = kampagne;
        const url = this.anreiseUrl + 'index.php?fId='
            + btoa(`data_etool/kampagne_${kennung}.csv`)
            + '&data='
            + btoa(encodeURI(JSON.stringify(data)));
        // console.log(kampagne.kennung);
        // console.log(data, url);
        return url;
    }

    renderQRcode(kampagne?: any) {
        const link = this.getToolUrl(kampagne);
        if (link) {
            QRCode.toDataURL(link, { width: 300, errorCorrectionLevel: 'H' })
                .then(qrUrl => {
                    this.setState({ qrUrl: qrUrl });
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    copyToClipboard() {
        const link = this.getToolUrl();
        if (link) {
            const textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            textarea.value = link;
            textarea.select();
            textarea.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(textarea.value);
            document.body.removeChild(textarea);
            alert('Link wurde kopiert!');
        }
    }

    openAnAbreiseTool() {
        const link = this.getToolUrl();
        if (link) {
            window.open(link, '_blank').focus();
        }
    }

    processData(kennung: string) {
        const link = this.anreiseUrl + `data_etool/kampagne_${kennung}.csv?stamp=${new Date().getTime()}`;
        fetch(link, {})
            .then(response => {
                return response.text();
            })
            .then(text => {
                const results = csvToJsonAnAbreise(text);
                const saveItem = { tid: this.state.dataItem.tid, daten: text, besucher_erfasst: results.personenzahl || 0, ergebnis: JSON.stringify(results) };
                this.dataService.saveData(IDs.ENT_ANABREISE, saveItem, undefined, false, (suc: boolean, saveTid: number) => {
                    this.triggerService.fire('reload', IDs.ENT_ANABREISE);
                    this.setState({ showSpinner: false });
                    alert('Es wurden ' + results.rows + ' Datensätze importiert!');
                }, IDs.MOD_ETOOL);
            })
            .catch((e) => {
                alert('Es wurden keine Datensätze gefunden.');
                console.error(e, link);
            });
    }

    exportCSV(kampagne: any) {
        const jsonStr = kampagne.ergebnis;
        let results: any;
        try {
            results = JSON.parse(jsonStr);
        } catch (e) {
            console.error(e, jsonStr);
        }
        if (!results || !results.entfernungen) {
            alert('Es wurden noch keine Daten erfasst und/oder importiert!');
            return;
        }

        const besucher_erwartet = this.state.dataItem.besucher;
        const besucher_erfasst = this.state.dataItem.besucher_erfasst;
        const faktor_hochrechnung = (besucher_erwartet / besucher_erfasst) || 1;
        const exportArr: Array<any> = [];

        const transportation = Object.keys(results.entfernungen || {}).map((k: string) => {
            return {
                key: k,
                ...results.entfernungen[k]
            };
        }).sort((a: any, b: any) => b.km - a.km);
        if (transportation.length > 0) {
            exportArr.push(['Entfernungen']);
            exportArr.push(['Transportmittel', 'Entfernung (km) erfasst', 'Personen erfasst', 'Entfernung (km) hochgerechnet']);
            transportation.forEach((t: any) =>
                exportArr.push([
                    getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'transportmittel', t.key),
                    fn0(t.km),
                    fn0(t.cnt),
                    fn2d(Math.round(t.km * faktor_hochrechnung))
                ])
            );
        }

        const uebernachtung = Object.keys(results.uebernachtungen || {}).map((k: string) => {
            return {
                key: k,
                ...results.uebernachtungen[k]
            };
        }).sort((a: any, b: any) => b.anzahl - a.anzahl);
        if (uebernachtung.length > 0) {
            exportArr.push([]);
            exportArr.push(['Übernachtungen']);
            exportArr.push(['Unterkunft', 'Übernachtungen erfasst', 'Personen erfasst', 'Übernachtungen hochgerechnet']);
            uebernachtung.forEach((u: any) =>
                exportArr.push([
                    getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'unterkunft', u.key),
                    fn0(u.anzahl),
                    fn0(u.cnt),
                    fn2d(Math.round(u.anzahl * faktor_hochrechnung * 100) / 100)
                ])
            )
        }

        // console.log(exportArr);
        let csv = '\ufeff' /* BOM */ + exportArr.map((r: Array<string>) => r.map((c: string) => `"${c}"`).join(';')).join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const filename = `Export An-/Abreise-Umfrage ${kampagne.kennung}.csv`;
        saveAs(url, filename);
    }
}
